import {
  Button,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { Layout } from '../../../navigation/components/Layout/Layout';
import { UserInfosRequiredCard } from '../../../user/components/UserInfosRequiredCard';
import { HeaderCard } from '../../components/HeaderCard';
import { LydiaPaymentCard } from './components/LydiaPaymentCard/LydiaPaymentCard';
import { MilestoneCard } from './components/MilestoneCard';
import { OnlinePaymentCard } from './components/OnlinePaymentCard/OnlinePaymentCard';
import { usePayment } from './usePayment';

export const Payment: FunctionComponent = () => {
  const {
    currentEvent,
    currentMilestone,
    hasGivenInformation,
    loading,
    nextMilestone,
    onGoToDashboard,
    onGoToEventRegister,
    onLeaveEvent,
    onGoToPaymentForSomeone,
  } = usePayment();

  return (
    <Layout title="Paiement" activeTab="payment">
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <HeaderCard />
          {hasGivenInformation ? (
            currentEvent ? (
              !currentEvent.hasJoined ? (
                <Card>
                  <CardContent>
                    <Typography variant="body2">
                      {`Vous n'avez pas encore rejoint l'événement. Veuillez vous inscrire avant de payer`}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button variant="contained" onClick={onGoToEventRegister}>
                      {`S'inscrire`}
                    </Button>
                  </CardActions>
                </Card>
              ) : currentEvent.hasPaidTicket ? (
                <>
                  <Card sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="body2">
                        {
                          'Le compte est bon ! Nous avons bien reçu votre paiement'
                        }
                      </Typography>
                      {currentEvent.userWhoPaidTicket &&
                      !currentEvent.userWhoPaidTicket.isMe ? (
                        <Typography variant="caption">
                          {`Votre paiement a été effectué par : ${currentEvent.userWhoPaidTicket.firstname} ${currentEvent.userWhoPaidTicket.lastname} ${currentEvent.userWhoPaidTicket.nickname ? `"${currentEvent.userWhoPaidTicket.nickname}"` : ''}`}
                        </Typography>
                      ) : null}
                    </CardContent>
                    <CardActions>
                      <Button variant="contained" onClick={onGoToDashboard}>
                        Retourner au Dashboard
                      </Button>
                      {currentEvent.isFull ? null : (
                        <Button
                          variant="outlined"
                          onClick={onGoToPaymentForSomeone}
                        >
                          {"Payer pour quelqu'un d'autre"}
                        </Button>
                      )}
                    </CardActions>
                  </Card>
                  {currentEvent.paidTransactionsForOtherUsers.length > 0 ? (
                    <Card>
                      <CardContent>
                        <Typography variant="body1">
                          {'Vous avez payé pour les personnes suivantes :'}
                        </Typography>
                        {currentEvent.paidTransactionsForOtherUsers.map(
                          (transaction) => (
                            <Typography variant="body2" key={transaction.id}>
                              {`- ${transaction.user.firstname} ${transaction.user.lastname} ${
                                transaction.user.nickname
                                  ? `"${transaction.user.nickname}"`
                                  : ''
                              }`}
                            </Typography>
                          ),
                        )}
                      </CardContent>
                    </Card>
                  ) : null}
                </>
              ) : currentEvent.isFull ? (
                <Card>
                  <CardContent>
                    <Typography variant="body1">
                      {`L'événement est complet. Vous êtes sur liste d'attente. L'orga vous contactera si une place se libère`}
                    </Typography>
                    {currentEvent.waitingListPosition ? (
                      <Typography variant="h6">
                        {`Votre place dans la liste d'attente : ${currentEvent.waitingListPosition}${currentEvent.waitingListPosition === 1 ? 'er' : 'ème'}`}
                      </Typography>
                    ) : null}
                    <Typography variant="body2">
                      {`Si vous ne souhaiez plus participer, merci de vous désinscrire pour libérer la place pour quelqu'un d'autre`}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button
                      variant="contained"
                      onClick={onLeaveEvent}
                      color="error"
                    >
                      {`Quitter l'événement`}
                    </Button>
                    <Button variant="contained" onClick={onGoToDashboard}>
                      Retourner au Dashboard
                    </Button>
                  </CardActions>
                </Card>
              ) : (
                <>
                  <Card sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="h6">
                        {"Nous n'avons pas encore reçu votre paiement"}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button variant="contained" onClick={onGoToDashboard}>
                        Retourner au Dashboard
                      </Button>
                    </CardActions>
                  </Card>
                  <MilestoneCard
                    currentMilestone={currentMilestone}
                    nextMilestone={nextMilestone}
                  />
                  {currentMilestone ? (
                    <OnlinePaymentCard
                      event={currentEvent}
                      milestone={currentMilestone}
                    />
                  ) : null}
                  {/* <Card sx={{ mb: 2 }}>
                    <CardContent>
                      <Typography variant="h6">{'Chèque'}</Typography>
                      <Typography variant="body1">
                        {
                          "Envoyez votre paiement par chèque en même temps que vos chèque de caution à l'adresse suivante :"
                        }
                      </Typography>
                      {currentEvent.checkAddress.split('\n').map((line) => (
                        <Typography variant="body2" key={line}>
                          {line}
                        </Typography>
                      ))}
                      <Typography variant="body1">
                        {
                          "Vous pouvez aussi les transmettre directement à l'organisation si vous en avez la possibilité"
                        }
                      </Typography>
                    </CardContent>
                  </Card> */}
                  {/* <Card sx={{ mb: 2 }}>
                  <CardContent>
                    <Typography variant="h6">{'Virement'}</Typography>
                    <Typography variant="body1">
                      {'Effectuez un virement au compte suivant :'}
                    </Typography>
                    <Typography variant="body2">
                      {'FR76 0000 0000 0000'}
                    </Typography>
                    <Typography variant="body2">{'AGRIFRPP003'}</Typography>
                    <Typography variant="body1">
                      {
                        "N'oubliez pas de préciser votre nom et prénom dans le libellé du virement. Si vous payez pour plusieurs personnes, merci de préciser le nom et prénom de chaque personne, ou contactez l'organisation"
                      }
                    </Typography>
                  </CardContent>
                </Card> */}
                  {currentEvent.lydiaLink ? (
                    <LydiaPaymentCard lydiaLink={currentEvent.lydiaLink} />
                  ) : null}
                </>
              )
            ) : null
          ) : (
            <UserInfosRequiredCard />
          )}
        </>
      )}
    </Layout>
  );
};
